import { FC } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import {
  GuestSubmissionPage,
  NotFoundPage,
  SignInPage,
  ForgotPasswordPage,
  ResetPasswordPage,
  CandidateDetailsPage,
  CandidateSummary,
  AvailableCandidatesPage,
  AvailableCandidateDetailsPage,
  SharePage,
  ShareRequestPage,
  LegalPage,
} from '@pages';
import { AppLayout, AuthLayout } from '@components';

import { AppRoutes, PRIVACY_POLICY, TERMS_OF_SERVICE } from '@constants';
import { PageTitle } from 'constants/pageTitle';
import { LayoutWrapper } from './LayoutWrapper';
import { CandidatesRoute } from './CandidatesRoute';
import { Teams } from 'pages/Teams/Teams';
import { MemberLayout } from 'pages/Teams/Member/MemberLayout';
import { MemberEvaluations } from 'pages/Teams/Member/MemberEvaluations';
import { MemberEvaluation } from 'pages/Teams/Member/MemberEvaluation';

const AppRouter: FC = () => (
  <Routes>
    <Route path={`/`}>
      {/* First frame of the app actually has isAppLoading = false, thats why this Nagivate is always triggered on index and redirect to candidate page is present in the path*/}
      <Route index element={<Navigate to={AppRoutes.CANDIDATES} />} />

      <Route element={<LayoutWrapper layout={AppLayout} />}>
        <Route path={AppRoutes.CANDIDATES} element={<CandidatesRoute />} />
        <Route
          path={AppRoutes.AVAILABLE_CANDIDATES}
          element={<AvailableCandidatesPage />}
        />
        <Route
          path={`${AppRoutes.AVAILABLE_CANDIDATES}/:candidateId`}
          element={<AvailableCandidateDetailsPage />}
        />
        <Route path={AppRoutes.TEAMS}>
          <Route index element={<Teams />} />
          <Route path=":teamId/members/:memberId" element={<MemberLayout />}>
            <Route path="evaluations" element={<MemberEvaluations />} />
            <Route
              path="evaluations/:evaluationId"
              element={<MemberEvaluation />}
            />
            <Route index element={<Navigate to="evaluations" replace />} />
          </Route>
        </Route>
        <Route
          path={`${AppRoutes.CANDIDATES}/:candidateId`}
          element={<CandidateDetailsPage />}
        />
        <Route path={AppRoutes.SHARE} element={<SharePage />} />
        <Route
          path={`${AppRoutes.SHARE_REQUEST}/:requestId`}
          element={<ShareRequestPage />}
        />
      </Route>

      <Route element={<LayoutWrapper layout={AuthLayout} />}>
        <Route path={AppRoutes.SIGN_IN} element={<SignInPage />} />
        <Route
          path={AppRoutes.FORGOT_PASSWORD}
          element={<ForgotPasswordPage />}
        />
        <Route
          path={AppRoutes.SET_PASSWORD}
          element={<ResetPasswordPage isNewPassword />}
        />
        <Route
          path={AppRoutes.RESET_PASSWORD}
          element={<ResetPasswordPage />}
        />
      </Route>
    </Route>
    <Route
      path={`${AppRoutes.CANDIDATE_SUMMARY}/:submissionId`}
      element={<CandidateSummary />}
    />
    <Route path={`${AppRoutes.GUEST_SUBMISSION}/:token`}>
      <Route index element={<GuestSubmissionPage />} />
      <Route path=":submissionId" element={<GuestSubmissionPage />} />
    </Route>
    <Route
      path={AppRoutes.TERMS}
      element={
        <LegalPage document={TERMS_OF_SERVICE} pageTitle={PageTitle.TERMS} />
      }
    />
    <Route
      path={AppRoutes.PRIVACY}
      element={
        <LegalPage document={PRIVACY_POLICY} pageTitle={PageTitle.PRIVACY} />
      }
    />
    <Route path="*" element={<NotFoundPage />} />
  </Routes>
);

export default AppRouter;
